export function SettingsSeparator() {
  return <div className="h-1 bg-divider my-30" />;
}
